var urlString = "https://varadatechsolutions.in/varadaapi/";
// var urlString = "http://localhost:8053/varadaapi/";
var schema;
// schema = JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_schema;
schema = "varadatechsolutions_db";
const PostApiCall = {
  postRequest(userData, url) {
    return fetch(urlString + url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        schema: schema,
      },
      body: JSON.stringify(userData),
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("request failed", error);
        return error;
      });
  },
};

export default PostApiCall;
